import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider, JourneyProvider } from "@/lib/site";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import Home from "@/pages/Home";
import Sell from "@/pages/Sell";
import Sent from "@/pages/Sent";
import Upload from "@/pages/Upload";
import ContentPage from "@/pages/ContentPage";
import Login from "@/pages/dealer/Login";
import ForgotPassword from "@/pages/dealer/ForgotPassword";
import SetPassword from "@/pages/dealer/SetPassword";
import DealerLayout from "@/pages/dealer/DealerLayout";
import Enquiries from "@/pages/dealer/Enquiries";
import EnquiryDetail from "@/pages/dealer/EnquiryDetail";
import Settings from "@/pages/dealer/Settings";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <JourneyProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sell" element={<Sell />} />
              <Route path="/sell/sent" element={<Sent />} />
              <Route path="/upload/:token" element={<Upload />} />
              <Route path="/privacy" element={<ContentPage name="privacy" title="Privacy information" />} />
              <Route path="/valuation-terms" element={<ContentPage name="valuation-terms" title="Valuation terms" />} />
              <Route path="/dealer/login" element={<Login />} />
              <Route path="/dealer/forgot-password" element={<ForgotPassword />} />
              <Route path="/dealer/set-password" element={<SetPassword />} />
              <Route path="/admin" element={<Navigate to="/dealer" replace />} />
              <Route path="/admin/*" element={<Navigate to="/dealer" replace />} />
              <Route path="/dealer" element={<RequireAuth><DealerLayout /></RequireAuth>}>
                <Route index element={<Enquiries />} />
                <Route path="test" element={<Enquiries test />} />
                <Route path="enquiries/:id" element={<EnquiryDetail />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </JourneyProvider>
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
